import { Modal } from 'antd';
import styles from '../Style/ContactModal.module.scss';

type PrivateProps = {
  visible: boolean;
  onHandleContactModalCancel: () => void;
};

export default function ContactModal({
  visible,
  onHandleContactModalCancel,
}: PrivateProps) {
  return (
    <Modal
      className={`contactModal ${styles.contactModal}`}
      title={[
        <div className={styles.modalTitle} key={'contactModal-title-container'}>
          <h1>Contact</h1>
        </div>,
      ]}
      open={visible}
      onCancel={onHandleContactModalCancel}
      width={'65vw'}
      footer={null}
    >
      <div className={styles.contactModalContent}>
        <div className={styles.contactText}>
          <h1>Do you have any questions?</h1>
          <div className={styles.contactTextContainer}>
            <div>
              {/* <h2>Email</h2> */}
              <div>
                <div>
                  <p className={styles.writeToUs}>Write to us at:</p>
                  <a href='mailto:metocean-on-demand@dhigroup.com'>
                    metocean-on-demand@dhigroup.com
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* UNCOMMENT IN CASE IS STILL NEEDED */}
        {/* <div ref={div} className={styles.contactForm}>
          <div className={styles.form}>
            <iframe
              frameBorder='0'
              id='41e17561-fb00-4f71-8f17-d36ba6cd8565'
              src={
                'https://7444fa84dfef4c4885ac3fa70f96dfe5.svc.dynamics.com/t/formsandbox/VFJBo-lF0GX0AF0edESN0g-HnOCEHyuo28Qo_a-Iq_M/6962b585-67e5-eb11-bacb-000d3a4639b4?ad=' +
                encodeURIComponent(document.location.toString())
              }
              height={`${height && height - 80}px`}
              width='100%'
            />
          </div>
        </div> */}
      </div>
    </Modal>
  );
}
